import { Connectivity, PlanType } from '@app-types/product';

import { formatPrice } from './utils';

type RadioStatus = {
    fourGRadio: {
        valid: boolean;
        description: string;
    };
    fiveGRadio: {
        valid: boolean;
        description: string;
    };
};

export function getRadioLabels(selectedProduct: PlanType, selectedNetwork: Connectivity): RadioStatus {
    if (!selectedProduct.option5g?.gencode) {
        return {
            fourGRadio: { valid: false, description: 'incluse' },
            fiveGRadio: { valid: true, description: 'incluse' },
        };
    }

    const option5gPrice = selectedProduct.option5g.prices?.final ?? 0;
    const isFourGSelected = selectedNetwork === Connectivity.FOUR_G;

    const formatPriceLabel = (price: number, isPositive: boolean = true): string => {
        if (price === 0) return 'incluse';
        return `${isPositive ? '+' : '-'}\u00A0${formatPrice(price)}/mois`;
    };

    return {
        fourGRadio: {
            valid: true,
            description: isFourGSelected ? 'incluse' : formatPriceLabel(option5gPrice, false),
        },
        fiveGRadio: {
            valid: true,
            description: isFourGSelected ? formatPriceLabel(option5gPrice) : 'incluse',
        },
    };
}
